import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const PublicContentActions = importer('Stores/PublicContent/Actions')
const { saveContactForm } = importer('APIs/public', null)
export default function * main ({ formData }) {
  try {
    yield put(PublicContentActions.saveContactFormLoading())
    const res = yield saveContactForm(formData)
    yield put(PublicContentActions.saveContactFormSuccess(res))
  } catch (error) {
    yield put(PublicContentActions.saveContactFormFailure(error))
  }
}
